import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IObservationSummary } from '../../../message-models/observation-summary.interface';
import { ObservationTypeString, ObservationType } from 'src/app/domain-model/observation.class';
import { MenuItem } from 'primeng/api';
import { ObservationSummary } from '../../../domain-model/observation-summary';
import { Router } from '@angular/router';

@Component({
  selector: 'app-recent-observations-list',
  templateUrl: './recent-observations-list.component.html',
  styleUrls: ['./recent-observations-list.component.scss']
})

export class RecentObservationsListComponent implements OnInit {
  @Input() recentObservations: Array<IObservationSummary>;
  @Input() allowEdit: boolean = true;
  @Input() allowDelete: boolean = true;

  @Output() viewObservationClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() createObservationClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() editObservationClicked: EventEmitter<string> = new EventEmitter<string>();
  @Output() deleteObservationClicked: EventEmitter<string> = new EventEmitter<string>();
  columns: any[];
  ObservationType: typeof ObservationType = ObservationType;
  ObservationTypeString: typeof ObservationTypeString = ObservationTypeString;
  rowMenuItems: MenuItem[];

  constructor(private router: Router) { }


  isOnMobile = false;
  ngOnInit(): void {
    this.isOnMobile = window.outerWidth <= 480;
    this.columns = [
      { field: 'operativeName', header: 'Owner', type: 'owner' },
      { field: 'observationType', header: 'Type', type: 'type' },
      { field: 'observedBy', header: 'Observer', type: 'text' },
      { field: 'observedOn', header: 'Date Observed', type: 'date' },
      { field: 'followUpOn', header: 'Followup', type: 'date' },

      { field: 'summaryInfo', header: 'Information', type: 'text' },
      { field: 'notesAsHtml', header: 'Notes', type: 'html' },
    ]

    this.rowMenuItems = [
      {
        label: 'Remove',
        icon: 'fas fa-trash-alt',
        styleClass: 'eca-menu-item-red',
        command: ($event) => this.deleteObservation($event)
      }
    ]
  }

  viewObservation(iObservationSummary?: IObservationSummary) {
    let observationSummary = new ObservationSummary(iObservationSummary);
    this.router.navigate(["/observation-details/" + observationSummary.observationId])
  }

  editObservation(observationId: string) {
    this.editObservationClicked.emit(observationId);
  }

  deleteObservation(observationId: string) {
    this.deleteObservationClicked.emit(observationId);
  }
}
